module.exports = __webpack_public_path__ + "img/cuadros-de-momentos.d60e2668.png";